<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
export default {
  name: "ScrollBoard",
  data() {
    return {
      config: {
        header: ["时间", "公开信息"],
        data: [
          ["2024-02-01 19:25:00", "尉氏县百茂硅胶科技有限公司 ​开足马力忙生产"],
          [
            "2024-02-02 17:25:00",
            "焦作市产城融合示范区 高职院校项目施工忙 铆足干劲奋战开门红",
          ],
          ["2024-02-03 16:25:00", "河南恒晖精细化工项目 热火朝天施工忙"],
          ["2024-02-04 15:25:00", "河南焦作科技传媒学院西校区建设项目加快推进"],
          ["2024-02-05 14:25:00", "焦作综保区平原智能汽车涂装生产线出海“圈粉”"],
          ["2024-02-07 12:25:00", "焦作综保区（三期）电子信息产业园顺利封顶"],
          ["2024-02-08 11:25:00", "焦作市运粮河引黄调蓄工程正式开工"],
          ["2024-02-09 10:25:00", "连霍高速焦作西收费站正式开通"],
          [
            "2024-02-10 09:25:00",
            "河南省“万人助万企”服务工作组到尉氏县开展工作对接",
          ],
        ],
        index: true,
        columnWidth: [50, 170],
        align: ["center"],
        rowNum: 7,
        headerBGC: "#1981f6",
        headerHeight: 45,
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
      },
    };
  },
};
</script>

<style lang="less">
#scroll-board {
  width: 40%;
  box-sizing: border-box;
  margin-left: 20px;
  height: 100%;
  overflow: hidden;
}
</style>
